import styled from 'styled-components';

export const Container = styled.div`
  background: ${props => props.theme.color.warn20};
  border: 1px solid ${props => props.theme.color.warn};
  border-left: 12px solid ${props => props.theme.color.warn};
  box-sizing: border-box;
  border-radius: 12px;
  padding: 16px;
  margin: 24px;
  font-size: 0.9rem;
  line-height: 1.3rem;

  h1 {
    font-style: ${props => props.theme.typograph.largerBold};
    color: ${props => props.theme.color.neutral};
    margin-bottom: 10px;
  }
`;

export const Icon = styled.img`
  position: relative;
  width: 24px;
  height: 24px;
  margin-right: 10px;
`;
